var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.333 6V3.6C8.333 1.615 6.838 0 5 0S1.667 1.615 1.667 3.6V6H0v6h10V6zm-1.11 0H2.777V3.6c0-1.324.997-2.4 2.222-2.4s2.223 1.076 2.223 2.4z"
})));
export default SvgIconLock;